module.exports = __webpack_public_path__ + "img/water.443e3684.jpg";